import { TODAY } from '../../constants';
import type { DateIso } from '../../types/domain';
import { getHolidaysCached } from './holidays';

/** Jour affiché dans la frise de la Timeline. */
export interface TimelineDay {
  d: Date;
  iso: DateIso;
  we: boolean;
  ferie: boolean;
  today: boolean;
}

export function isWE(d: Date): boolean {
  return d.getDay() === 0 || d.getDay() === 6;
}

export function isoStr(d: Date): DateIso {
  const y = d.getFullYear(),
    m = String(d.getMonth() + 1).padStart(2, '0'),
    day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function dateFromIso(s: DateIso): Date {
  const [y, m, d] = s.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function addDays(d: Date, n: number): Date {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
}

export function isoWeek(d: Date): number {
  const t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (t.getUTCDay() + 6) % 7;
  t.setUTCDate(t.getUTCDate() - day + 3);
  const firstThu = new Date(Date.UTC(t.getUTCFullYear(), 0, 4));
  const fd = (firstThu.getUTCDay() + 6) % 7;
  firstThu.setUTCDate(firstThu.getUTCDate() - fd + 3);
  return 1 + Math.round((t.getTime() - firstThu.getTime()) / (7 * 86400000));
}

export function diffDays(a: Date, b: Date): number {
  return Math.round((b.getTime() - a.getTime()) / 86400000);
}

export function buildDays(tlStart: Date, tlDays: number): TimelineDay[] {
  const days: TimelineDay[] = [];
  for (let i = 0; i < tlDays; i++) {
    const d = addDays(tlStart, i);
    const iso = isoStr(d);
    days.push({
      d,
      iso,
      we: isWE(d),
      ferie: getHolidaysCached(d.getFullYear()).has(iso),
      today: iso === isoStr(TODAY),
    });
  }
  return days;
}
